import React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import apps from '../../enums/AppsInfo';
import OtherApplicationsPaths from '../../helpers/OtherApplicationsPaths';
import routes from '../../helpers/ApplicationRoutes';
import * as organizationSelectors from '../../selectors/organizationSelectors';
import * as bucketSelectors from '../../selectors/bucketSelectors';

const DASHBOARD = 'dashboard';

class AppsSwitcher extends React.Component {
    constructor(props) {
        super(props);
        this.state = { appSelected: DASHBOARD };
    }

    onGoToApp = e => {
        e.preventDefault();
        const { bucket, organization, history, onClosePopover } = this.props;

        this.setState({ appSelected: e.target.id }, () => {
            if (this.state.appSelected !== DASHBOARD) {
                let route;
                if (bucket) {
                    route = OtherApplicationsPaths.apps[
                        this.state.appSelected
                    ].project.getPath({
                        id: bucket.id,
                    });
                } else {
                    route = OtherApplicationsPaths.apps[
                        this.state.appSelected
                    ].root.getPath();
                }
                window.open(route, '_blank');
                onClosePopover();
            } else {
                history.push(
                    routes.organization.getPath({
                        organizationId: organization.id,
                    }),
                );
                onClosePopover();
            }
        });
    };

    render() {
        const { classes } = this.props;

        let appsList = apps
            .filter(app => !app.exclude)
            .map(app => {
                const appClasses = classNames(classes.item);

                let switcherItem = (
                    <div
                        key={app.context}
                        id={app.context}
                        onClick={this.onGoToApp}
                        className={appClasses}
                    >
                        <div
                            id={app.context}
                            className={classes.itemRightWrapper}
                        >
                            <img
                                id={app.context}
                                src={app.icon}
                                alt={app.alt}
                                className={classes.itemIcon}
                            />
                            <span className={classes.itemText} id={app.context}>
                                {app.name}
                            </span>
                        </div>
                    </div>
                );
                return switcherItem;
            });

        return <React.Fragment>{appsList}</React.Fragment>;
    }
}

AppsSwitcher.propTypes = {
    onClosePopover: PropTypes.func.isRequired,
    bucket: PropTypes.object,
};

const mapStateToProps = state => ({
    bucket: bucketSelectors.getBucket(state),
    organization: organizationSelectors.getOrganization(state),
});

const style = ({ spacing, palette }) => ({
    itemIcon: {
        height: 28,
        width: 28,
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        justifyContent: 'space-between',
        height: 48,
        paddingLeft: spacing.unit * 2,
        '&:hover': {
            backgroundColor: palette.background.gray1Color,
        },
    },
    selected: {
        pointerEvents: 'none',
        backgroundColor: palette.background.gray1Color,
    },
    itemRightWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    itemText: {
        paddingLeft: spacing.unit * 2,
        fontSize: 14,
        verticalAlign: 'middle',
        color: palette.text.tertiary,
        letterSpacing: 0,
    },
    checkIcon: {
        height: 24,
        width: 24,
        paddingRight: spacing.unit * 2,
    },
});

export default withRouter(
    connect(mapStateToProps)(injectSheet(style)(AppsSwitcher)),
);



// WEBPACK FOOTER //
// ./src/containers/appsDropdown/AppsSwitcher.js